"use client";
import { createPortal } from 'react-dom';
import { useId } from 'react';
import usePortal from './use-portal.js';

/**
 * @component Portal
 * @package Portal
 * @document ../_docs/code/portal.editor.tsx
 * @document ../_docs/code/portal.snippet.tsx
 * @document ../_docs/code/portal.import.tsx
 */
const Portal = ({ id, children }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const portalId = id || useId();
    const target = usePortal(portalId);
    return createPortal(children, target);
};

export { Portal, Portal as default };
